import { AuthTokens, Token } from 'types/auth'

/**
 * Sets the tokens in the session storage
 *
 * @param {AuthTokens} tokens
 */
const setTokens = (tokens: AuthTokens) => {
  sessionStorage.setItem('access_token', JSON.stringify(tokens.token))
  sessionStorage.setItem('refresh_token', JSON.stringify(tokens.refreshToken))
}

/**
 * Returns the access token from the session storage
 *
 * @returns Token
 */
const getAccessToken = (): Token | undefined => {
  const sessionStorageAccessToken = sessionStorage.getItem('access_token')

  return sessionStorageAccessToken ? JSON.parse(sessionStorageAccessToken) : undefined
}

/**
 * Returns the refresh token from the session storage
 *
 * @returns Token
 */
const getRefreshToken = (): Token | undefined => {
  const sessionStorageRefreshToken = sessionStorage.getItem('refresh_token')

  return sessionStorageRefreshToken ? JSON.parse(sessionStorageRefreshToken) : undefined
}

/**
 * Clears the tokens in the session storage
 */
const clearTokens = () => {
  sessionStorage.removeItem('access_token')
  sessionStorage.removeItem('refresh_token')
}

export { setTokens, getAccessToken, getRefreshToken, clearTokens }
